import React from "react";
import ProjectForm from "./ProjectForm";

const AddProject = () => {
  return <ProjectForm />;
};

export default AddProject;
